// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6062":"506d5062","6123":"3f32d107","6346":"ae4b1c27"}[chunkId] + ".chunk.css";
};